/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from './BaseCom';
import Card from './Card';
import FormInput from './FormInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import { qreq } from '../shared/qrequest';
import './Examination.css';
import Vitals from './Vitals';
import ExaminationProperties from './ExaminationProperties';
import ExaminationWound from './ExaminationWound';
import MessageDialog from './MessageDialog';
import AppActions from './AppActions';
import DiagCodeSelect from './DiagCodeSelect';
import L from './Lang';

export default class Examination extends BaseCom {

    constructor(props) {
        super(props);
        if (!props.item.examination)
            props.item.examination = {};
        this.comID = uuidv4();
        this.state = {
            item: props.item.examination,
            examination: props.examination ?? {}
        };
        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
        this.woundsUpdated = this.woundsUpdated.bind(this);
        this.onWoundPhotoChanged = this.onWoundPhotoChanged.bind(this);
        if (!this.state.item.woundPosList)
            this.state.item.woundPosList = [];
        if (!this.state.item.woundPosFeetList)
            this.state.item.woundPosFeetList = [];
    }

    componentDidMount() {
        this.woundIdx = this.state.item.woundPosList.length + this.state.item.woundPosFeetList.length;
        this.onScroll = () => {
            var el = document.getElementById(this.comID + '-examination-save');
            var rect = el.getBoundingClientRect();
            if (rect.y < 0)
                this.setState({ examinationToolbarSave: true });
            else
                this.setState({ examinationToolbarSave: false });
        };
        window.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    }


    componentDidUpdate(prevProps) {
        if (this.props.item) {
            if (prevProps.item.examination !== this.props.item.examination) {
                if (!this.props.item.examination)
                    this.props.item.examination = {};
                if (!this.props.item.examination.woundPosList)
                    this.props.item.examination.woundPosList = [];
                if (!this.props.item.examination.woundPosFeetList)
                    this.props.item.examination.woundPosFeetList = [];
                this.setState({ item: this.props.item.examination });
            }
        }
    }

    onChange() {
        this.setState({ item: this.state.item });
        this.woundsUpdated();
    }

    woundsUpdated() {
        /*
        var item = {...this.state.item};
        var visit = {...this.props.visit};
        var woundList = [...item.woundPosList].concat(item.woundPosFeetList);

        visit.wounds = [];

        this.props.visit.wounds.forEach(i => {
            if(i.id)
                visit.wounds.push(i);
        });

        woundList.forEach(i => {
            if(i.size) {
                var p = i.size.split('x');
                i.sizeLength = p[0];
                if(p.length > 1)
                    i.sizeWidth = p[1];
                if(p.length > 2)
                    i.sizeDepth = p[2];
            }
            visit.wounds.push(i);
        });

        if(this.props.onVisitUpdate)
            this.props.onVisitUpdate(visit);
        */
    }

    save() {
        if (!this.state.item) {
            this.alert('Examination is blank.');
            return;
        }

        var exam = { id: this.props.item.id ?? 0, jsonData: JSON.stringify(this.state.item), visit: { ...this.props.visit } };
        if (this.props.visit)
            exam.visitID = Number(this.props.visit.id);
        else if (this.props.patientID)
            exam.patientID = Number(this.props.patientID);
        exam.riskTab = this.props.tab;

        if (exam.visit?.products)
            delete exam.visit.products;

        this.setState({ saving: true });

        qreq.post('/api/examination/save', exam, j => {
            if (j.errorCode === 0) {
                this.success('Examination saved!');
                this.setState({ item: JSON.parse(j.item.jsonData), examination: JSON.parse(j.item.jsonData) });
                this.props.onSave?.(j.item);
            }
            else
                this.alert(j.errorMessage);
            this.setState({ saving: false });
        }, () => {
            this.setState({ saving: false });
            this.unkownErrorCallback();
        });
    }

    onWoundPhotoChanged(wound) {
        var find = this.state.item.woundPosList.find(i => i.id ? i.id === wound.id : i.idx === wound.idx);
        if (find) {
            find.base64Content = wound.base64Content;
            find.fileName = wound.fileName;
            find.mimeType = wound.mimeType;
            find.dataSize = wound.dataSize;
            find.images = wound.images;
        }
        else {
            find = this.state.item.woundPosFeetList.find(i => i.id ? i.id === wound.id : i.idx === wound.idx);
            if (find) {
                find.base64Content = wound.base64Content;
                find.fileName = wound.fileName;
                find.mimeType = wound.mimeType;
                find.dataSize = wound.dataSize;
                find.images = wound.images;
            }
        }
    }

    render() {
        var woundList = [...this.state.item.woundPosList].concat(this.state.item.woundPosFeetList);

        return <div className="Examination">
            {this.state.saving && <MessageDialog title="Saving" message="Saving please wait..." />}
            <div id={this.comID + '-examination-save'}></div>
            {!this.props.disabled && <AppActions>
                <button type="button" className="btn btn-success btn-lg" onClick={this.save}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button>
            </AppActions>}
            <ExaminationProperties item={this.state.examination} />
            <Vitals item={this.state.item} onChange={this.onChange} disabled={this.props.disabled} />
            <ExaminationWound item={this.state.item} woundList={woundList} onWoundPhotoChanged={this.onWoundPhotoChanged} onChange={this.onChange} onSelectWound={this.woundsUpdated} disabled={this.props.disabled} />
            <Card title="Plans and Procedures">
                <div className="row">
                    <div className="col-md">
                        <FormInput model={this.state.item} name="woundCareOrders" label="Wound Care Orders" type="textarea" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                    <div className="col-md">
                        <FormInput model={this.state.item} name="woundCareProcedures" label="Wound Care Procedures" type="textarea" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                </div>
                <FormInput model={this.state.item} name="woundCarePlan" label="Wound Care Plan" type="textarea" disabled={this.props.disabled} onChange={this.onChange} />
            </Card>
            <DiagCodeSelect item={this.props.visit} onChange={() => this.props.onVisitUpdate(this.props.visit)} disabled={this.props.disabled} />
            <Card title="Musculoskeletal System Review">
                <div className="row">
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="grossStructure" label="Gross Structure/posture" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.grossStructure === 'Impaired' ? <FormInput model={this.state.item} name="grossStructureMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="grossROM" label="Gross ROM" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.grossROM === 'Impaired' ? <FormInput model={this.state.item} name="grossROMMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="grossStrength" label="Gross Strength" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.grossStrength === 'Impaired' ? <FormInput model={this.state.item} name="grossStrengthMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="height" label="Height" type="number" step="0.01" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="weight" label="Weight" type="number" step="0.01" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="bmi" label="BMI" type="number" step="0.01" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                </div>
            </Card>
            <Card title="Neuromuscular System Review">
                <div className="row">
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="bedMobility" label="Bed Mobility" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.bedMobility === 'Impaired' ? <FormInput model={this.state.item} name="bedMobilityMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="transfers" label="Transfers" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.transfers === 'Impaired' ? <FormInput model={this.state.item} name="transfersMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="gaitMobilityBalance" label="Gait Mobility/Balance" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.gaitMobilityBalance === 'Impaired' ? <FormInput model={this.state.item} name="gaitMobilityBalanceMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                </div>
            </Card>
            <Card title="Gastrointestinal System Review">
                <div className="row">
                    <div className="col-md">
                        <FormInput model={this.state.item} name="gastrointestinalSystemReview" label="Gastrointestinal System Review" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.gastrointestinalSystemReview === 'Impaired' ? <FormInput model={this.state.item} name="gastrointestinalSystemReviewMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                </div>
            </Card>
            <Card title="Urogenital System Review">
                <div className="row">
                    <div className="col-md">
                        <FormInput model={this.state.item} name="urogenitalSystemReview" label="Urogenital System Review" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.gastrointestinalSystemReview === 'Impaired' ? <FormInput model={this.state.item} name="urogenitalSystemReviewMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                </div>
            </Card>
            <Card title="Integumentary System Review">
                <div className="row">
                    <div className="col-md">
                        <FormInput model={this.state.item} name="skinIntegrity" label="Skin Integrity" type="text" disabled={this.props.disabled} onChange={this.onChange} />
                        <FormInput model={this.state.item} name="skinColor" label="Skin Color" type="text" disabled={this.props.disabled} onChange={this.onChange} />
                        <FormInput model={this.state.item} name="scarFormation" label="Scar Formation" type="text" disabled={this.props.disabled} onChange={this.onChange} />
                        <FormInput model={this.state.item} name="hair/nail Growth" label="Hair/Nail Growth" type="text" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                </div>
            </Card>
            <Card title="Communication, Affect, Learning style">
                <div className="row">
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="communication" label="Communication" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.communication === 'Impaired' ? <FormInput model={this.state.item} name="communicationMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="oreintation" label="Orientation X3" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.oreintation === 'Impaired' ? <FormInput model={this.state.item} name="oreintationMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="emotionalResponse" label="Emotional/behavioral" type="select" options={[{ id: 'Not Impaired', name: 'Not Impaired' }, { id: 'Impaired', name: 'Impaired' }]} disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.emotionalResponse === 'Impaired' ? <FormInput model={this.state.item} name="emotionalResponseMore" label="Details" type="text" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="learningBariers" label="Learning Bariers" type="text" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="alternateLearner" label="Alternate learner" type="text" disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                    <div className="col-md-4">
                        <FormInput model={this.state.item} name="preferredLearningStyle" label="Preferred learning style" type="select" options={[{ id: 'Verbal', name: 'Verbal' }, { id: 'Written', name: 'Written' }, { id: 'Pictures/Visual', name: 'Pictures/Visual' }, { id: 'Demonstration', name: 'Demonstration' }]} disabled={this.props.disabled} onChange={this.onChange} />
                    </div>
                </div>
            </Card>
            <Card title="Tests and Measures">
                <div className="row">
                    <div className="col-md-6">
                        <FormInput model={this.state.item} name="painAtRest" label="At Rest" type="switch" disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.painAtRest ? <FormInput model={this.state.item} name="painAtRestMore" label="Details" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-6">
                        <FormInput model={this.state.item} name="painWithActivity" label="With Activity" type="switch" disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.painWithActivity ? <FormInput model={this.state.item} name="painWithActivityMore" label="Details" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <FormInput model={this.state.item} name="painWithElevation" label="With Elevation" type="switch" disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.painWithElevation ? <FormInput model={this.state.item} name="painWithElevationMore" label="Details" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                    <div className="col-md-6">
                        <FormInput model={this.state.item} name="painWithDependency" label="With Dependency" type="switch" disabled={this.props.disabled} onChange={this.onChange} />
                        {this.state.item.painWithDependency ? <FormInput model={this.state.item} name="painWithDependencyMore" label="Details" disabled={this.props.disabled} onChange={this.onChange} /> : ''}
                    </div>
                </div>
            </Card>
        </div>;
    }
}